import { Box } from "@chakra-ui/react";
import * as Html from 'view-layer/styled/html';
import { currencyFormat } from 'business-layer/helpers/currencyFormat';

interface PropsType {
  label: string,
  currency: string,
  amount: string | number,
}

export const PropertyAmount = ({ label, currency, amount }: PropsType) => (
  <Box data-testid="amount-value" fontSize={'14px'} lineHeight={'20px'} pt={1}>
    {label}: <Html.Strong>{currency.toLocaleLowerCase() === 'usd' ? '$' : `${currency.toUpperCase()} `}{currencyFormat(amount)}</Html.Strong>
  </Box>
);
